var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 5,
    viewBox: "0 0 16 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 2.5C10.25 3.75 9.21875 4.75 8 4.75C6.75 4.75 5.75 3.75 5.75 2.5C5.75 1.28125 6.75 0.25 8 0.25C9.21875 0.25 10.25 1.28125 10.25 2.5ZM13.5 0.25C14.7188 0.25 15.75 1.28125 15.75 2.5C15.75 3.75 14.7188 4.75 13.5 4.75C12.25 4.75 11.25 3.75 11.25 2.5C11.25 1.28125 12.25 0.25 13.5 0.25ZM2.5 0.25C3.71875 0.25 4.75 1.28125 4.75 2.5C4.75 3.75 3.71875 4.75 2.5 4.75C1.25 4.75 0.25 3.75 0.25 2.5C0.25 1.28125 1.25 0.25 2.5 0.25Z",
    fill: "#3C2212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.2a70031437a8cc41683afd0ececf4028.svg";
export { ForwardRef as ReactComponent };